import React from "react";

import { TablePagination } from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const Pagination = (props) => {
  const { t } = useTranslation()
  return (
    <TablePagination
      component="div"
      {...props}
      labelRowsPerPage={t('Rows per page')}
      labelDisplayedRows={
        ({ from, to, count }) => {
          return `${from} - ${to} ${t('of')} ${count}`
        }
      }
    />
  );
};

Pagination.propTypes = {
  /** The total number of rows. */
  count: PropTypes.number,
  /** The number of rows per page. */
  rowsPerPage: PropTypes.number,
  /** The zero-based index of the current page. */
  page: PropTypes.number,
  /** Customizes the options of the rows per page select field  */
  rowsPerPageOptions: PropTypes.array,
  /** Function when the page change*/
  onPageChange: PropTypes.func,
  /** Function */
  onRowsPerPageChange: PropTypes.func,
};

export default Pagination;
